var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.584 22H12.416l5.538 18h14.092l5.538-18zm-25.168-4c-2.691 0-4.615 2.604-3.823 5.176l5.538 18A4 4 0 0017.954 44h14.092a4 4 0 003.823-2.824l5.538-18C42.2 20.604 40.275 18 37.584 18H12.416zM29.972 15a4.5 4.5 0 00-8.945 0h-4.013a8.5 8.5 0 0116.97 0h-4.012z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/Cart-Icon.df69ab5b6894ffe0fe0903a83822dc51.svg";
export { ForwardRef as ReactComponent };